<div class="container-fluid">
  <main role="main">
    <div class="container-fluid">
      <div class="col-12">
        <div class="animate-fade-in">
          <header class="page-header">
            <div class="header-left">
              @if (goBackUrl) {
                <button
                  [routerLink]="goBackUrl"
                  [queryParams]="goBackQueryParams"
                  class="back-btn"
                  title="Back to Employees">
                  <i class="bi bi-arrow-left"></i>
                </button>
              }

              <div class="header-titles">
                <h1 class="product-name">{{ title }}</h1>
                <span class="product-category">
                  {{ subtitle }}
                </span>
              </div>
            </div>
          </header>

          <div class="px-0">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
